(function(){
  var TZ=10; // Brisbane, UTC+10, no daylight saving
  function q(s){return document.querySelectorAll(s);}
  function setColour(b){
    q('.ph__sw').forEach(function(x){x.setAttribute('aria-checked',x===b?'true':'false');});
    q('[data-ph-name]').forEach(function(el){el.textContent=b.dataset.name;});
    q('[data-ph-colour]').forEach(function(el){el.style.color=b.dataset.text||'';});
  }
  function syncKaching(name){
    q('select.kaching-bundles__bar-variant-select').forEach(function(s){
      if([].some.call(s.options,function(o){return o.value===name;}) && s.value!==name){
        s.value=name; s.dispatchEvent(new Event('change',{bubbles:true})); s.dispatchEvent(new Event('input',{bubbles:true}));
      }
    });
  }
  function showPhoto(key){
    if(!key)return;
    var th=[].find.call(q('.shop-thumbnail'),function(t){var i=t.querySelector('img');return i&&(i.currentSrc||i.src).indexOf(key)>-1;});
    if(th){th.click();}
  }
  function addBiz(d,n){d=new Date(d);while(n>0){d.setUTCDate(d.getUTCDate()+1);var w=d.getUTCDay();if(w!==0&&w!==6)n--;}return d;}
  function fmt(d){var D=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],M=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];return D[d.getUTCDay()]+' '+d.getUTCDate()+' '+M[d.getUTCMonth()];}
  function go(){
    var root=document.querySelector('.ph--b'); if(!root)return;
    var form=document.getElementById(root.dataset.form);
    q('.ph__sw').forEach(function(b){
      b.addEventListener('click',function(){
        setColour(b);
        var inp=(form||document).querySelector('input[name="id"]');
        if(inp){inp.value=b.dataset.id;inp.dispatchEvent(new Event('change',{bubbles:true}));}
        syncKaching(b.dataset.name);
        showPhoto(b.dataset.img);
        try{var u=new URL(location.href);u.searchParams.set('variant',b.dataset.id);history.replaceState({},'',u);}catch(e){}
      });
    });
    document.addEventListener('change',function(e){
      var s=e.target; if(!s.matches||!s.matches('select.kaching-bundles__bar-variant-select'))return;
      var b=document.querySelector('.ph__sw[data-name="'+s.value+'"]'); if(b&&b.getAttribute('aria-checked')!=='true')setColour(b);
    });
    var cd=root.querySelector('[data-ph-cd]'); if(!cd)return;
    function p(n){return n<10?'0'+n:''+n;}
    function tick(){
      var local=new Date(Date.now()+TZ*3600000);                       // Brisbane wall clock (read with UTC getters)
      var mid=Date.UTC(local.getUTCFullYear(),local.getUTCMonth(),local.getUTCDate()+1);
      var s=Math.max(0,Math.floor((mid-local.getTime())/1000));
      cd.querySelector('[data-h]').textContent=p(Math.floor(s/3600));
      cd.querySelector('[data-m]').textContent=p(Math.floor(s%3600/60));
      cd.querySelector('[data-s]').textContent=p(s%60);
      var today=new Date(Date.UTC(local.getUTCFullYear(),local.getUTCMonth(),local.getUTCDate()));
      cd.querySelector('[data-from]').textContent=fmt(addBiz(today,8));
      cd.querySelector('[data-to]').textContent=fmt(addBiz(today,15));
    }
    tick();setInterval(tick,1000);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
})();

/* ---- Bundle cards: honest savings + clean layout (works on top of Kaching) ---- */
(function(){
  function money(t){var n=parseFloat(String(t||'').replace(/[^0-9.]/g,''));return isNaN(n)?null:n;}
  function fm(n){return '$'+(Math.round(n*100)/100).toFixed(2).replace(/\.00$/,'');}
  function el(tag,cls,txt){var e=document.createElement(tag);e.className=cls;if(txt!=null)e.textContent=txt;return e;}
  function put(parent,cls,tag,txt,before){
    var e=parent.querySelector(':scope > .'+cls);
    if(txt==null){if(e)e.remove();return;}
    if(!e){e=el(tag,cls);before?parent.insertBefore(e,before):parent.appendChild(e);}
    if(e.textContent!==txt)e.textContent=txt;
  }
  var busy=false;
  function apply(){
    if(busy)return;busy=true;
    try{
      var bars=[].slice.call(document.querySelectorAll('.kaching-bundles__bar'));
      if(!bars.length)return;
      var unit=money((bars[0].querySelector('.kaching-bundles__bar-price')||{}).textContent);
      var best=null,bestPer=1e9;
      bars.forEach(function(b){
        var qty=parseInt((b.querySelector('.kaching-bundles__bar-title')||{}).textContent,10)||b.querySelectorAll('select.kaching-bundles__bar-variant-select').length||1;
        var price=money((b.querySelector('.kaching-bundles__bar-price')||{}).textContent);
        b.dataset.pkQty=qty;
        if(price&&price/qty<bestPer-0.01){bestPer=price/qty;best=b;}
        var first=b.querySelector('.kaching-bundles__bar-first-line');
        var second=b.querySelector('.kaching-bundles__bar-second-line');
        var pricing=b.querySelector('.kaching-bundles__bar-pricing');
        var full=unit&&price&&qty>1?unit*qty:null, save=full?full-price:0;
        if(first)put(first,'pk-save','span',save>=1?'SAVE '+fm(Math.round(save)):null);
        var lab=b.querySelector('.kaching-bundles__bar-label'), sub=b.querySelector('.kaching-bundles__bar-subtitle');
        if(second)put(second,'pk-sub','div',(lab&&lab.textContent.trim())||(qty===1?'Just the one':(sub&&sub.textContent.trim())||''));
        if(pricing)put(pricing,'pk-was','div',save>=1?fm(full):null);
      });
      bars.forEach(function(b){
        var c=b.querySelector('.kaching-bundles__bar-container')||b;
        put(c,'pk-tab','span',(b===best&&bars.length>1)?'Best value':null,c.firstChild);
      });
    }finally{busy=false;}
  }
  function start(){
    var root=document.querySelector('.kaching-bundles');
    if(!root){return setTimeout(start,400);}
    apply();
    var t;new MutationObserver(function(){if(busy)return;clearTimeout(t);t=setTimeout(apply,30);}).observe(root,{childList:true,subtree:true,characterData:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();

/* ---- Payment icons: give each SVG unique ids so clip-paths render (duplicate ids hide some logos) ---- */
(function(){
  function fix(){
    document.querySelectorAll('.payment-icons-wrapper svg').forEach(function(svg,n){
      if(svg.dataset.pkIds)return;svg.dataset.pkIds='1';
      var map={};
      svg.querySelectorAll('[id]').forEach(function(el){var o=el.id,nw='pk'+n+'-'+o;map[o]=nw;el.id=nw;});
      if(!Object.keys(map).length)return;
      svg.querySelectorAll('*').forEach(function(el){
        [].slice.call(el.attributes).forEach(function(a){
          var v=a.value,c=v.replace(/url\(#([^)]+)\)/g,function(m,id){return map[id]?'url(#'+map[id]+')':m;});
          if((a.name==='href'||a.name==='xlink:href')&&v.charAt(0)==='#'&&map[v.slice(1)])c='#'+map[v.slice(1)];
          if(c!==v)el.setAttribute(a.name,c);
        });
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fix);else fix();
})();
